import { render, staticRenderFns } from "./combined-sold-products.vue?vue&type=template&id=0a629cc8&scoped=true"
import script from "./combined-sold-products.vue?vue&type=script&lang=js"
export * from "./combined-sold-products.vue?vue&type=script&lang=js"
import style0 from "./combined-sold-products.vue?vue&type=style&index=0&id=0a629cc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a629cc8",
  null
  
)

export default component.exports